// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2otXz","label":"CategoryService_label__1FkA_","location":"CategoryService_location__Yzm4M"};